/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PostApiBookingGroupsVisitGroupIdCancel200, PostApiBookingGroupsVisitGroupIdCancel403, PostApiBookingGroupsVisitGroupIdCancel404, PostApiBookingGroupsVisitGroupIdCancel409, PostApiBookingGroupsVisitGroupIdCancel500, PostApiBookingGroupsVisitGroupIdCancelMutationResponse, PostApiBookingGroupsVisitGroupIdCancelPathParams, PostApiBookingGroupsVisitGroupIdCancelQueryParams } from "../entities/PostApiBookingGroupsVisitGroupIdCancel";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { modelsMessageResponseSchema } from "./models/messageResponseSchema";
import { z } from "zod/v4";

export const postApiBookingGroupsVisitGroupIdCancelPathParamsSchema = z.object({
    "visit_group_id": z.string().describe("ID группы записей")
    }) as unknown as z.ZodType<PostApiBookingGroupsVisitGroupIdCancelPathParams>

export const postApiBookingGroupsVisitGroupIdCancelQueryParamsSchema = z.object({
    "branch_id": z.coerce.number().int().min(1).describe("ID филиала")
    }) as unknown as z.ZodType<PostApiBookingGroupsVisitGroupIdCancelQueryParams>

/**
 * @description OK
 */
export const postApiBookingGroupsVisitGroupIdCancel200Schema = z.lazy(() => modelsMessageResponseSchema) as unknown as z.ZodType<PostApiBookingGroupsVisitGroupIdCancel200>

/**
 * @description Forbidden
 */
export const postApiBookingGroupsVisitGroupIdCancel403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBookingGroupsVisitGroupIdCancel403>

/**
 * @description Not Found
 */
export const postApiBookingGroupsVisitGroupIdCancel404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBookingGroupsVisitGroupIdCancel404>

/**
 * @description Conflict
 */
export const postApiBookingGroupsVisitGroupIdCancel409Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBookingGroupsVisitGroupIdCancel409>

/**
 * @description Internal Server Error
 */
export const postApiBookingGroupsVisitGroupIdCancel500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBookingGroupsVisitGroupIdCancel500>

export const postApiBookingGroupsVisitGroupIdCancelMutationResponseSchema = z.lazy(() => postApiBookingGroupsVisitGroupIdCancel200Schema) as unknown as z.ZodType<PostApiBookingGroupsVisitGroupIdCancelMutationResponse>